module.exports = __webpack_public_path__ + "img/beauty_red-eye-removal.2a7c1bc.svg";